import { useEffect, useContext, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import UserContext from "../contexts/UserContext";
import Utils from "../Utils";
import axios from "axios";
import _ from "lodash";
import { ViewAnnotation } from "../components/common";

import ThumbnailList from "../components/photographer/ThumbnailList";

/**
 * Main Recce Viewer page.
 * - Holds images array
 * - Holds per-image saved data (strokes + comments)
 * - Handles Save (show JSON + optional POST)
 */
const RecceViewer = () => {
  const { rfname, pid, mode } = useParams();
  const { userData } = useContext(UserContext);

  // active image index
  const [recceImages, setRecceImages] = useState([]);

  useEffect(() => {
    axios
      .get(Utils.apiUrl(`photoshoot/recces/${pid}/${mode}`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setRecceImages(res.data.data);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  const getActiveImage = () => {
    return recceImages.find((img) => img.fname === rfname) || null;
  };

  // store per-image data: { [imageId]: { strokes: [...], comments: [...], image: src } }
  const [imageDataMap, setImageDataMap] = useState({});

  // comment modal state handled by CanvasArea -> forwarded here for global display if needed
  const [jsonOutput, setJsonOutput] = useState("");

  // Called by CanvasArea when strokes/comments changed (autosave to local memory)
  const handleUpdateImageData = useCallback((imageId, data) => {
    setImageDataMap((prev) => ({ ...prev, [imageId]: data }));
  }, []);

  const title = mode === "recce" ? "Photoshoot Recce" : "Styling Deck";

  const getReccedImages = (images) => {
    // reorder images latest images.set of recced images first, then the rest
    let reccedImages = images.filter(
      (img) => img.status !== "submitted" && img.va_feedback !== null,
    );
    reccedImages = _.sortBy(
      reccedImages,
      (img) => new Date(img.va_feedback?.created_at),
    ).reverse();
    return reccedImages;
  };

  return (
    <div className="page-wrap min-h-screen bg-gray-50">
      <main
        className="flex-area container mx-auto px-2 py-1"
        style={{ minHeight: "calc(100vh - 80px)" }}
      >
        <div>
          <div className="text-center text-xl mb-2">
            <a
              href={`${process.env.PUBLIC_URL}/photoshoot-details/${pid}`}
              className="btn text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
            >
              <i className="fas fa-arrow-left mr-2"></i> Back
            </a>
          </div>
          <aside
            className="thumb-column"
            style={{
              maxHeight: "calc(100vh - 100px)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {recceImages.length > 0 && (
              <ThumbnailList
                mode={mode}
                images={getReccedImages(recceImages)}
                activeId={getActiveImage().id}
              />
            )}
          </aside>
        </div>
        <section className=" flex-1">
          <div className="text-xl font-bold text-gray-800 w-full text-center flex-1 bg-gray-200 py-2 px-4 mb-2 rounded">
            {title} Annotation Viewer
          </div>
          <div className="preview">
            {getActiveImage() != null && (
              <ViewAnnotation image={getActiveImage()} mode="recce" />
            )}

            {getActiveImage() && getActiveImage().status === "bt-processed" && (
              <div className="flex flex-col md:flex-row mt-6 md:mt-10 gap-6">
                <div className="flex-1">
                  <label className="text-base block mb-2">
                    Feedback by Brand Team
                  </label>
                  <div className="block messagetobt mb-2">
                    <div className="rounded-lg w-full py-2 px-3 bg-white-100 border border-gray-300 focus:shadow-outline">
                      {_.get(
                        getActiveImage(),
                        "ai_feedback",
                        "No feedback provided.",
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

export default RecceViewer;
